import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class CostingExpenses {
  async fetch(params = {}) {

    const query = new URLSearchParams({
      page: params.page ?? 1,
      perPage: params.pageSize ?? 10,

      customer_id: params.customer_id ?? "",
      invoice_id: params.invoice_id ?? "",
      from_date: params.from_date ?? "",
      to_date: params.to_date ?? "",
    }).toString();

    const response = await ajaxService.get(`/expenses?${query}`);

    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewExpense(id) {
    const response = await ajaxService.get(`/expenses/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async editExpense(id, data) {
    const response = await ajaxService.post(`/expenses/update/`, data, id);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const costingExpenseService = new CostingExpenses();
export default costingExpenseService;
